

import React, { useRef, useState, useMemo } from "react";
import { Tag, Typography, Input, Button, Tabs, Table, Modal, Checkbox, Upload, Select, Form } from "antd";
import { SearchOutlined, EyeInvisibleOutlined, CloseOutlined, CloudUploadOutlined, InfoCircleOutlined, DownOutlined } from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './DashboardHotel.scss';
import { Segmented } from "antd";
import Cleartrip from "../../assets/images/Cleartrip.jpg";
import { AgCharts } from "ag-charts-react";
import { useNavigate } from "react-router-dom";


function DashboardHotels() {
    const ref = useRef(null);
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState("my data");
    const [isPromoteModalOpen, setIsPromoteModalOpen] = useState(false);
    const [isAssignMemberModalOpen, setIsAssignMemberModalOpen] = useState(false);
    const [selectedClients, setSelectedClients] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedYear, setSelectedYear] = useState("2025");

    const items = [
        {
            key: "1",
            label: "Recon A",
        },
        {
            key: "2",
            label: "Recon B",
        },
    ];

    const cardsData = [
        {
            title: "Total Revenue",
            value: "₹16,23,456",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.5 11.875C12.5 12.2065 12.3683 12.5245 12.1339 12.7589C11.8995 12.9933 11.5815 13.125 11.25 13.125H10.625V10.625H11.25C11.5815 10.625 11.8995 10.7567 12.1339 10.9911C12.3683 11.2255 12.5 11.5435 12.5 11.875ZM18.125 10C18.125 11.607 17.6485 13.1779 16.7557 14.514C15.8629 15.8502 14.594 16.8916 13.1093 17.5065C11.6247 18.1215 9.99099 18.2824 8.4149 17.9689C6.8388 17.6554 5.39106 16.8815 4.25476 15.7452C3.11846 14.6089 2.34463 13.1612 2.03112 11.5851C1.71762 10.009 1.87852 8.37535 2.49348 6.8907C3.10844 5.40605 4.14985 4.1371 5.486 3.24431C6.82214 2.35152 8.39303 1.875 10 1.875C12.1542 1.87727 14.2195 2.73403 15.7427 4.25727C17.266 5.78051 18.1227 7.84581 18.125 10ZM13.75 11.875C13.75 11.212 13.4866 10.5761 13.0178 10.1072C12.5489 9.63839 11.913 9.375 11.25 9.375H10.625V6.875H10.9375C11.269 6.875 11.587 7.0067 11.8214 7.24112C12.0558 7.47554 12.1875 7.79348 12.1875 8.125C12.1875 8.29076 12.2534 8.44973 12.3706 8.56694C12.4878 8.68415 12.6467 8.75 12.8125 8.75C12.9783 8.75 13.1372 8.68415 13.2544 8.56694C13.3717 8.44973 13.4375 8.29076 13.4375 8.125C13.4375 7.46196 13.1741 6.82607 12.7053 6.35723C12.2364 5.88839 11.6005 5.625 10.9375 5.625H10.625V5C10.625 4.83424 10.5592 4.67527 10.4419 4.55806C10.3247 4.44085 10.1658 4.375 10 4.375C9.83424 4.375 9.67527 4.44085 9.55806 4.55806C9.44085 4.67527 9.375 4.83424 9.375 5V5.625H9.0625C8.39946 5.625 7.76358 5.88839 7.29474 6.35723C6.8259 6.82607 6.5625 7.46196 6.5625 8.125C6.5625 8.78804 6.8259 9.42393 7.29474 9.89277C7.76358 10.3616 8.39946 10.625 9.0625 10.625H9.375V13.125H8.75C8.41848 13.125 8.10054 12.9933 7.86612 12.7589C7.6317 12.5245 7.5 12.2065 7.5 11.875C7.5 11.7092 7.43416 11.5503 7.31695 11.4331C7.19974 11.3158 7.04076 11.25 6.875 11.25C6.70924 11.25 6.55027 11.3158 6.43306 11.4331C6.31585 11.5503 6.25 11.7092 6.25 11.875C6.25 12.538 6.5134 13.1739 6.98224 13.6428C7.45108 14.1116 8.08696 14.375 8.75 14.375H9.375V15C9.375 15.1658 9.44085 15.3247 9.55806 15.4419C9.67527 15.5592 9.83424 15.625 10 15.625C10.1658 15.625 10.3247 15.5592 10.4419 15.4419C10.5592 15.3247 10.625 15.1658 10.625 15V14.375H11.25C11.913 14.375 12.5489 14.1116 13.0178 13.6428C13.4866 13.1739 13.75 12.538 13.75 11.875ZM7.8125 8.125C7.8125 8.45652 7.9442 8.77446 8.17862 9.00888C8.41304 9.2433 8.73098 9.375 9.0625 9.375H9.375V6.875H9.0625C8.73098 6.875 8.41304 7.0067 8.17862 7.24112C7.9442 7.47554 7.8125 7.79348 7.8125 8.125Z" fill="#046666" />
                </svg>
            )
        },
        {
            title: "Total Bookings",
            value: "2213",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
                    <path d="M6.44536 0V6.14393C6.44536 7.21536 6.9475 7.72607 8.01893 7.72607H14.0793V15.3264C14.0793 17.0675 13.2171 17.9464 11.4843 17.9464H2.595C0.870357 17.9464 0 17.0761 0 15.3264V2.62821C0 0.887143 0.870357 0 2.59464 0H6.44536ZM10.7896 9.60964C10.7233 9.54328 10.6446 9.49065 10.5579 9.45473C10.4712 9.41882 10.3783 9.40033 10.2845 9.40033C10.1906 9.40033 10.0977 9.41882 10.0111 9.45473C9.92437 9.49065 9.84562 9.54328 9.77929 9.60964L5.9375 13.4518L5.40893 13.9136L4.9275 13.4518L3.58536 12.11C3.45064 11.9799 3.27021 11.9079 3.08293 11.9095C2.89564 11.9111 2.71649 11.9863 2.58406 12.1187C2.45162 12.2511 2.3765 12.4303 2.37488 12.6176C2.37325 12.8049 2.44524 12.9853 2.57536 13.12L4.9275 15.4721C5.06145 15.6061 5.2431 15.6813 5.4325 15.6813C5.6219 15.6813 5.80355 15.6061 5.9375 15.4721L10.7896 10.6196C10.9235 10.4857 10.9988 10.304 10.9988 10.1146C10.9988 9.92524 10.9235 9.74359 10.7896 9.60964ZM7.58357 0.0917857C7.93536 0.150714 8.28678 0.393572 8.67178 0.795357L13.2925 5.49107C13.6857 5.90107 13.9282 6.23607 13.9871 6.57929H8.04428C7.7425 6.57929 7.58357 6.42857 7.58357 6.12714V0.0917857Z" fill="#046666" />
                </svg>
            )
        },
        {
            title: "No.of Corporates",
            value: "24",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M18.125 17.5H16.25V2.5H16.875C17.0408 2.5 17.1997 2.43415 17.3169 2.31694C17.4342 2.19973 17.5 2.04076 17.5 1.875C17.5 1.70924 17.4342 1.55027 17.3169 1.43306C17.1997 1.31585 17.0408 1.25 16.875 1.25H3.125C2.95924 1.25 2.80027 1.31585 2.68306 1.43306C2.56585 1.55027 2.5 1.70924 2.5 1.875C2.5 2.04076 2.56585 2.19973 2.68306 2.31694C2.80027 2.43415 2.95924 2.5 3.125 2.5H3.75V17.5H1.875C1.70924 17.5 1.55027 17.5658 1.43306 17.6831C1.31585 17.8003 1.25 17.9592 1.25 18.125C1.25 18.2908 1.31585 18.4497 1.43306 18.5669C1.55027 18.6842 1.70924 18.75 1.875 18.75H18.125C18.2908 18.75 18.4497 18.6842 18.5669 18.5669C18.6842 18.4497 18.75 18.2908 18.75 18.125C18.75 17.9592 18.6842 17.8003 18.5669 17.6831C18.4497 17.5658 18.2908 17.5 18.125 17.5ZM6.875 4.375H8.75C8.91576 4.375 9.07473 4.44085 9.19194 4.55806C9.30915 4.67527 9.375 4.83424 9.375 5C9.375 5.16576 9.30915 5.32473 9.19194 5.44194C9.07473 5.55915 8.91576 5.625 8.75 5.625H6.875C6.70924 5.625 6.55027 5.55915 6.43306 5.44194C6.31585 5.32473 6.25 5.16576 6.25 5C6.25 4.83424 6.31585 4.67527 6.43306 4.55806C6.55027 4.44085 6.70924 4.375 6.875 4.375ZM6.875 7.5H8.75C8.91576 7.5 9.07473 7.56585 9.19194 7.68306C9.30915 7.80027 9.375 7.95924 9.375 8.125C9.375 8.29076 9.30915 8.44973 9.19194 8.56694C9.07473 8.68415 8.91576 8.75 8.75 8.75H6.875C6.70924 8.75 6.55027 8.68415 6.43306 8.56694C6.31585 8.44973 6.25 8.29076 6.25 8.125C6.25 7.95924 6.31585 7.80027 6.43306 7.68306C6.55027 7.56585 6.70924 7.5 6.875 7.5ZM6.25 11.25C6.25 11.0842 6.31585 10.9253 6.43306 10.8081C6.55027 10.6908 6.70924 10.625 6.875 10.625H8.75C8.91576 10.625 9.07473 10.6908 9.19194 10.8081C9.30915 10.9253 9.375 11.0842 9.375 11.25C9.375 11.4158 9.30915 11.5747 9.19194 11.6919C9.07473 11.8092 8.91576 11.875 8.75 11.875H6.875C6.70924 11.875 6.55027 11.8092 6.43306 11.6919C6.31585 11.5747 6.25 11.4158 6.25 11.25ZM11.875 17.5H8.125V14.375H11.875V17.5ZM13.125 11.875H11.25C11.0842 11.875 10.9253 11.8092 10.8081 11.6919C10.6908 11.5747 10.625 11.4158 10.625 11.25C10.625 11.0842 10.6908 10.9253 10.8081 10.8081C10.9253 10.6908 11.0842 10.625 11.25 10.625H13.125C13.2908 10.625 13.4497 10.6908 13.5669 10.8081C13.6842 10.9253 13.75 11.0842 13.75 11.25C13.75 11.4158 13.6842 11.5747 13.5669 11.6919C13.4497 11.8092 13.2908 11.875 13.125 11.875ZM13.125 8.75H11.25C11.0842 8.75 10.9253 8.68415 10.8081 8.56694C10.6908 8.44973 10.625 8.29076 10.625 8.125C10.625 7.95924 10.6908 7.80027 10.8081 7.68306C10.9253 7.56585 11.0842 7.5 11.25 7.5H13.125C13.2908 7.5 13.4497 7.56585 13.5669 7.68306C13.6842 7.80027 13.75 7.95924 13.75 8.125C13.75 8.29076 13.6842 8.44973 13.5669 8.56694C13.4497 8.68415 13.2908 8.75 13.125 8.75ZM13.125 5.625H11.25C11.0842 5.625 10.9253 5.55915 10.8081 5.44194C10.6908 5.32473 10.625 5.16576 10.625 5C10.625 4.83424 10.6908 4.67527 10.8081 4.55806C10.9253 4.44085 11.0842 4.375 11.25 4.375H13.125C13.2908 4.375 13.4497 4.44085 13.5669 4.55806C13.6842 4.67527 13.75 4.83424 13.75 5C13.75 5.16576 13.6842 5.32473 13.5669 5.44194C13.4497 5.55915 13.2908 5.625 13.125 5.625Z" fill="#046666" />
                </svg>
            )
        }
    ];

    const hotelsData = [
        {
            key: '1',
            rank: 1,
            hotelName: 'The Oberoi',
            complianceScore: '93%'
        },
        {
            key: '2',
            rank: 2,
            hotelName: 'The Taj Mahal Palace',
            complianceScore: '92%'
        },
        {
            key: '3',
            rank: 3,
            hotelName: 'The Leela Palace',
            complianceScore: '92%'
        },
        {
            key: '4',
            rank: 4,
            hotelName: 'ITC Maurya',
            complianceScore: '91%'
        },
        {
            key: '5',
            rank: 5,
            hotelName: 'Umaid Bhawan',
            complianceScore: '91%'
        }
    ];

    // Hotel icon mapping - add hotel icons here
    const hotelIcons = {
        'The Oberoi': 'https://static-assets.finkraftai.com/logo/oberoi.png',
        // Add more hotel icons as needed
    };

    const renderHotelName = (text) => {
        const hasIcon = hotelIcons[text];
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {hasIcon ? (
                    <img
                        src={hotelIcons[text]}
                        alt={text}
                        className="hotel-icon"
                        onError={(e) => {
                            // Fallback to generic icon if image fails to load
                            e.target.style.display = 'none';
                            const fallback = e.target.parentElement.querySelector('.name-icon');
                            if (fallback) fallback.style.display = 'block';
                        }}
                    />
                ) : (
                    <div className="name-icon"></div>
                )}
                <span>{text}</span>
            </div>
        );
    };

    const hotelsColumns = [
        {
            title: 'Rank',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
        },
        {
            title: 'Hotel name',
            dataIndex: 'hotelName',
            key: 'hotelName',
            render: renderHotelName,
        },
        {
            title: 'Compliance Score',
            dataIndex: 'complianceScore',
            key: 'complianceScore',
            align: 'right',
        },
    ];

    const clientsData = [
        {
            key: '1',
            client: 'Deloitte',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '2',
            client: 'KPMG',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '3',
            client: 'PWC',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '4',
            client: 'EY',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '5',
            client: 'BCG',
            promoted: 'Yes',
            status: 'Active'
        }
    ];

    const renderClientName = (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div className="name-icon"></div>
            <span>{text}</span>
        </div>
    );

    const renderPromoted = (text) => (
        <span style={{ color: text === 'Yes' ? '#10B981' : '#EF4444' }}>
            {text}
        </span>
    );

    const renderStatus = (text) => (
        <Button
            className={`status-badge ${text === 'Active' ? 'status-active' : 'status-pending'}`}
            size="small"
            style={{
                border: 'none',
                borderRadius: '4px',
                height: 'auto',
                padding: '4px 12px',
                fontSize: '13px',
                fontWeight: 500,
                fontFamily: 'Noto Sans',
                cursor: 'default',
                pointerEvents: 'none'
            }}
        >
            {text}
        </Button>
    );

    const clientsColumns = [
        {
            title: 'Client',
            dataIndex: 'client',
            key: 'client',
            render: renderClientName,
        },
        {
            title: 'Promoted',
            dataIndex: 'promoted',
            key: 'promoted',
            render: renderPromoted,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: renderStatus,
        },
    ];

    const clientsList = [
        { id: 1, name: 'Tata Group' },
        { id: 2, name: 'Reliance Industries' },
        { id: 3, name: 'HDFC Bank' },
        { id: 4, name: 'Infosys' },
        { id: 5, name: 'ICICI Bank' },
        { id: 6, name: 'State Bank of India' },
    ];

    // Corporate logo mapping
    // const corporateLogos = {
    //     'Deloitte': { bg: '#000000', text: 'D', color: 'white' },
    //     'KPMG': { bg: '#00338D', text: 'KPMG', color: 'white' },
    //     'PwC': { bg: '#FF6B35', text: 'pwc', color: 'white' },
    //     'EY': { bg: '#000000', text: 'EY', color: 'white' },
    //     'BCG': { bg: '#00A86B', text: 'BCG', color: 'white' },
    // };

    // // Render corporate name with logo
    // const renderCorporateName = (params) => {
    //     const corporateName = params.value;
    //     const logoConfig = corporateLogos[corporateName] || { bg: '#E1E6EA', text: corporateName.charAt(0), color: '#161922' };
        
    //     return (
    //         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    //             <div
    //                 style={{
    //                     width: '40px',
    //                     height: '40px',
    //                     borderRadius: '50%',
    //                     backgroundColor: logoConfig.bg,
    //                     color: logoConfig.color,
    //                     display: 'flex',
    //                     alignItems: 'center',
    //                     justifyContent: 'center',
    //                     fontSize: '14px',
    //                     fontWeight: 600,
    //                     fontFamily: 'Noto Sans',
    //                 }}
    //             >
    //                 {logoConfig.text}
    //             </div>
    //             <span style={{ fontFamily: 'Noto Sans', fontSize: '14px', color: '#161922' }}>{corporateName}</span>
    //         </div>
    //     );
    // };

    // Render Compliance Status
    const renderComplianceStatus = (params) => {
        const invoiceUploaded = params.data.invoiceUploaded || 0;
        const totalBookings = params.data.totalBookings || 0;
        
        // Calculate compliance status: invoiceUploaded / totalBookings
        let compliancePercentage = 0;
        if (totalBookings > 0) {
            compliancePercentage = (invoiceUploaded / totalBookings) * 100;
        }
        
        // Determine color based on ranking (highest = green, medium = yellow, lowest = red)
        let color;
        const { topThirdThreshold, bottomThirdThreshold } = complianceRankings;
        
        if (compliancePercentage >= topThirdThreshold) {
            // Highest percentage - Green
            color = '#10B981';
        } else if (compliancePercentage <= bottomThirdThreshold) {
            // Lowest percentage - Red
            color = '#EF4444';
        } else {
            // Medium percentage - Yellow
            color = '#F0B100';
        }
        
        return (
            <span
                style={{
                    color: color,
                    fontFamily: 'Noto Sans',
                    fontSize: '14px',
                    fontWeight: 400,
                }}
            >
                {compliancePercentage.toFixed(1)}%
            </span>
        );
    };

    // Render Action buttons
    const renderAction = (params) => {
        return (
            <div style={{ display: "flex", gap: "8px", justifyContent: "center", width: "100%" }}>
                <Button
                    style={{
                        color: '#00A76F',
                        borderColor: '#00A76F',
                        backgroundColor: 'white',
                        fontFamily: 'Noto Sans',
                        fontSize: '13px',
                        fontWeight: 500,
                    }}
                    size="small"
                    onClick={() => {
                        const corporateName = params.data.corporateName;
                        navigate(`/hotel-booking-hotel?corporateName=${encodeURIComponent(corporateName)}`);
                    }}
                >
                    View Transaction
                </Button>
                <Button
                    style={{
                        color: '#DC8225',
                        borderColor: '#DC8225',
                        backgroundColor: 'white',
                        fontFamily: 'Noto Sans',
                        fontSize: '13px',
                        fontWeight: 500,
                    }}
                    size="small"
                    onClick={() => {
                        setIsAssignMemberModalOpen(true);
                    }}
                >
                    Assign Member
                </Button>
            </div>
        );
    };

    // Column definitions for Corporate Overview table
    const columnDefs = [
        {
            headerName: 'Corporate Name',
            field: 'corporateName',
            filter: 'agTextColumnFilter',
            sortable: true,
            //cellRenderer: renderCorporateName,
            width: 250,
        },
        {
            headerName: 'Total bookings',
            field: 'totalBookings',
            filter: 'agNumberColumnFilter',
            sortable: true,
            cellStyle: { textAlign: 'right' },
            width: 150,
        },
        {
            headerName: 'Invoice Uploaded',
            field: 'invoiceUploaded',
            filter: 'agNumberColumnFilter',
            sortable: true,
            cellStyle: { textAlign: 'right' },
            width: 150,
        },
        {
            headerName: 'Invoice Pending',
            field: 'invoicePending',
            filter: 'agNumberColumnFilter',
            sortable: true,
            cellStyle: { textAlign: 'right' },
            width: 150,
        },
        {
            headerName: 'Compliance Status',
            field: 'complianceStatus',
            filter: 'agNumberColumnFilter',
            sortable: true,
            cellRenderer: renderComplianceStatus,
            width: 150,
            valueGetter: (params) => {
                const invoiceUploaded = params.data.invoiceUploaded || 0;
                const totalBookings = params.data.totalBookings || 0;
                if (totalBookings > 0) {
                    return (invoiceUploaded / totalBookings) * 100;
                }
                return 0;
            },
        },
        {
            headerName: 'Action',
            field: 'action',
            cellRenderer: renderAction,
            sortable: false,
            filter: false,
            width: 280,
            cellStyle: { 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
        },
    ];

    // Row data for Corporate Overview
    const rowData = [
        {
            corporateName: 'SAINT - GOBAIN INDIA',
            totalBookings: 45,
            invoiceUploaded: 34,
            invoicePending: 11,
            pocStatus: 'Available',
        },
        {
            corporateName: 'HCL TECHNOLOGIES',
            totalBookings: 120,
            invoiceUploaded: 115,
            invoicePending: 5,
            pocStatus: 'Available',
        },
        {
            corporateName: 'HCL TECHNOLOGIES',
            totalBookings: 65,
            invoiceUploaded: 60,
            invoicePending: 5,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'Lupin',
            totalBookings: 75,
            invoiceUploaded: 72,
            invoicePending: 3,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'Lupin',
            totalBookings: 90,
            invoiceUploaded: 85,
            invoicePending: 5,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'Lupin',
            totalBookings: 5439,
            invoiceUploaded: 2749,
            invoicePending: 2690,
            pocStatus: 'Available',
        },
        {
            corporateName: 'PANASONIC LIFE SOLUTIONS',
            totalBookings: 1642,
            invoiceUploaded: 97,
            invoicePending: 1545,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'PANASONIC LIFE SOLUTIONS',
            totalBookings: 791,
            invoiceUploaded: 0,
            invoicePending: 791,
            pocStatus: 'Available',
        },
        {
            corporateName: 'Skoda',
            totalBookings: 622,
            invoiceUploaded: 0,
            invoicePending: 622,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'Lupin',
            totalBookings: 1,
            invoiceUploaded: 0,
            invoicePending: 1,
            pocStatus: 'Available',
        },
        {
            corporateName: 'PANASONIC LIFE SOLUTIONS',
            totalBookings: 1,
            invoiceUploaded: 0,
            invoicePending: 1,
            pocStatus: 'Not Available',
        },
        {
            corporateName: 'Skoda',
            totalBookings: 730,
            invoiceUploaded: 0,
            invoicePending: 730,
            pocStatus: 'Available',
        },
    ];

    // Calculate compliance percentages and determine rankings
    const complianceRankings = useMemo(() => {
        const percentages = rowData.map(item => {
            const invoiceUploaded = item.invoiceUploaded || 0;
            const totalBookings = item.totalBookings || 0;
            return totalBookings > 0 ? (invoiceUploaded / totalBookings) * 100 : 0;
        });
        
        // Sort percentages in descending order (highest first)
        const sortedPercentages = [...percentages].sort((a, b) => b - a);
        
        // Find the highest, medium, and lowest thresholds
        const highest = sortedPercentages[0] || 0;
        const lowest = sortedPercentages[sortedPercentages.length - 1] || 0;
        
        // Determine which values are in the top third (highest), middle third, and bottom third (lowest)
        const oneThird = Math.ceil(sortedPercentages.length / 3);
        const topThirdThreshold = sortedPercentages[oneThird - 1] || 0;
        const bottomThirdThreshold = sortedPercentages[sortedPercentages.length - oneThird] || 0;
        
        return {
            percentages,
            highest,
            lowest,
            topThirdThreshold,
            bottomThirdThreshold
        };
    }, [rowData]);

    // Performance chart data
    const performanceData = [
        { month: 'Jan', value: 48 },
        { month: 'Feb', value: 86 },
        { month: 'Mar', value: 40 },
        { month: 'Apr', value: 32 },
        { month: 'May', value: 86 },
        { month: 'Jun', value: 32 },
        { month: 'Jul', value: 48 },
        { month: 'Aug', value: 32 },
        { month: 'Sep', value: 32 },
        { month: 'Oct', value: 40 },
        { month: 'Nov', value: 32 },
        { month: 'Dec', value: 86 },
    ];

    // Ranking chart data
    const rankingData = [
        { month: 'Jan', value: 2.5 },
        { month: 'Feb', value: 2.5 },
        { month: 'Mar', value: 3 },
        { month: 'Apr', value: 5 },
        { month: 'May', value: 8 },
        { month: 'Jun', value: 10.5 },
        { month: 'Jul', value: 11 },
        { month: 'Aug', value: 10.5 },
        { month: 'Sep', value: 10.5 },
        { month: 'Oct', value: 11.5 },
        { month: 'Nov', value: 13 },
        { month: 'Dec', value: 14.5 },
    ];

    // Performance chart options
    const performanceChartOptions = {
        theme: "ag-default",
        data: performanceData,
        series: [
            {
                type: "bar",
                direction: "vertical",
                xKey: "month",
                yKey: "value",
                fill: "#0a8394",
                stroke: "#0a8394",
                label: {
                    enabled: false,
                },
                tooltip: {
                    enabled: true,
                    renderer: (params) => {
                        const value = params.datum.value || 0;
                        return {
                            content: `<div style="text-align: left;">
                                <strong>Month:</strong> ${params.datum.month}<br/>
                                <strong>Value:</strong> ${value}
                            </div>`
                        };
                    }
                }
            },
        ],
        axes: [
            {
                type: "category",
                position: "bottom",
                label: {
                    fontSize: 12,
                    fontFamily: "Noto Sans",
                    color: "#7D7D82",
                },
                line: {
                    stroke: "#E1E6EA",
                },
                gridStyle: [{ stroke: "#E1E6EA", lineDash: [5, 5] }],
            },
            {
                type: "number",
                position: "left",
                label: {
                    fontSize: 12,
                    fontFamily: "Noto Sans",
                    color: "#7D7D82",
                },
                line: {
                    stroke: "#E1E6EA",
                },
                gridStyle: [{ stroke: "#E1E6EA", lineDash: [5, 5] }],
                min: 0,
                max: 100,
                tick: {
                    interval: 20,
                },
            },
        ],
        background: {
            fill: "transparent",
        },
        padding: {
            top: 20,
            right: 20,
            bottom: 40,
            left: 50,
        },
    };

    // Ranking chart options
    const rankingChartOptions = {
        theme: "ag-default",
        data: rankingData,
        series: [
            {
                type: "line",
                xKey: "month",
                yKey: "value",
                stroke: "#0a8394",
                strokeWidth: 2,
                marker: {
                    enabled: true,
                    shape: "circle",
                    size: 4,
                    fill: "#0a8394",
                    stroke: "#fff",
                },
            },
        ],
        axes: [
            {
                type: "category",
                position: "bottom",
                label: {
                    fontSize: 12,
                    fontFamily: "Noto Sans",
                    color: "#7D7D82",
                },
                line: {
                    stroke: "#E1E6EA",
                },
                gridStyle: [{ stroke: "#E1E6EA", lineDash: [5, 5] }],
            },
            {
                type: "number",
                position: "left",
                label: {
                    fontSize: 12,
                    fontFamily: "Noto Sans",
                    color: "#7D7D82",
                },
                line: {
                    stroke: "#E1E6EA",
                },
                gridStyle: [{ stroke: "#E1E6EA", lineDash: [5, 5] }],
                min: 0,
                max: 20,
                tick: {
                    interval: 5,
                },
            },
        ],
        background: {
            fill: "transparent",
        },
        padding: {
            top: 20,
            right: 20,
            bottom: 40,
            left: 50,
        },
    };

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
        >
            <PageHeader
                style={{ height: '60px', flexShrink: 0 }}
                leftActions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect width="40" height="40" rx="4" fill="#8C734C" />
                            <path d="M29.9499 9.07643L30.9575 8.47134V5L27.0215 7.32484M30.5796 6.17834V8.34395L29.6665 6.71975L30.5796 6.17834ZM30.0443 8.66242L28.218 7.57962L29.1312 7.03822L30.0443 8.66242Z" fill="white" />
                            <path d="M29.6354 9.61818L26.707 7.89844V12.58L29.6354 10.8602M27.4942 8.822L29.3205 9.90481H27.4942V8.822ZM27.4942 11.6246V10.5417H29.3205L27.4942 11.6246Z" fill="white" />
                            <path d="M31.5879 11.9742V15.4456L35.5554 13.1207L32.627 11.3691M31.9972 14.2672V12.1016L32.9104 13.7258L31.9972 14.2672ZM33.4457 13.4074L32.5325 11.7832L34.3588 12.866L33.4457 13.4074Z" fill="white" />
                            <path d="M32.9414 9.61818V10.8284L35.8698 12.5481V7.89844M35.0511 11.6246L33.2248 10.5417H35.0511V11.6246ZM35.0511 9.90481H33.2248L35.0511 8.822V9.90481Z" fill="white" />
                            <path d="M35.5554 7.32484L31.5879 5V8.47134L32.5955 9.07643M31.9972 6.17834L32.9104 6.71975L31.9972 8.34395V6.17834ZM33.4457 7.03822L34.3588 7.57962L32.5325 8.66242L33.4457 7.03822Z" fill="white" />
                            <path d="M27.0215 13.1207L30.989 15.4456V11.9742L29.9499 11.3691M30.5796 14.2672L29.6665 13.7258L30.5796 12.1016V14.2672ZM29.1312 13.4074L28.218 12.866L30.0443 11.7832L29.1312 13.4074Z" fill="white" />
                            <path d="M9.19943 24.9683C9.19943 26.6244 9.19943 28.0575 9.10497 28.8218C9.04199 29.3314 8.94753 29.7454 8.56968 29.8091C8.41224 29.8409 8.19182 29.8728 7.93992 29.8728C7.7195 29.8728 7.65653 29.9365 7.65653 30.032C7.65653 30.1594 7.78248 30.2231 8.00289 30.2231C8.72712 30.2231 9.86068 30.1594 10.27 30.1594C10.7738 30.1594 11.9074 30.2231 13.1039 30.2231C13.2929 30.2231 13.4503 30.1594 13.4503 30.032C13.4503 29.9365 13.3558 29.8728 13.1669 29.8728C12.8835 29.8728 12.5057 29.8409 12.2538 29.8091C11.7185 29.7454 11.624 29.3314 11.561 28.8218C11.4666 28.0256 11.4666 26.6244 11.4666 24.9365V17.5161L13.7337 17.5798C15.3396 17.6116 15.8119 18.1212 15.8434 18.5989L15.8749 18.79C15.9064 19.0766 15.9378 19.1403 16.0638 19.1403C16.1583 19.1403 16.2212 19.0447 16.2212 18.8537C16.2212 18.3759 16.2842 17.1339 16.2842 16.7517C16.2842 16.4651 16.2527 16.3696 16.1268 16.3696C15.9693 16.3696 15.56 16.5607 14.3949 16.5607H7.27867C6.6804 16.5607 6.01916 16.5288 5.48386 16.4651C5.04303 16.4333 4.8541 16.2422 4.69666 16.2422C4.6022 16.2422 4.53923 16.3377 4.47625 16.5925C4.47625 16.7517 4.12988 18.4078 4.12988 18.6944C4.12988 18.8855 4.16137 18.981 4.28732 18.981C4.38179 18.981 4.44476 18.9173 4.47625 18.7581C4.50774 18.5989 4.6022 18.4078 4.79113 18.1212C5.07452 17.739 5.48386 17.6435 6.52296 17.6116L9.19943 17.5479" fill="white" />
                            <path d="M22.8032 25.5092L22.9607 25.6366L24.3776 29.4901C24.4721 29.713 24.3461 29.8722 24.2202 29.9041C24.0313 29.9359 23.9683 29.9678 23.9683 30.0633C23.9683 30.1907 24.1887 30.1907 24.5036 30.2225C25.9205 30.2544 27.18 30.2544 27.8098 30.2544C28.471 30.2544 28.6285 30.2225 28.6285 30.0633C28.6285 29.9359 28.534 29.9041 28.4081 29.9041C28.1877 29.9041 27.9358 29.8722 27.6838 29.8404C27.306 29.7448 26.8022 29.4901 26.1409 27.8659C25.0074 25.0951 22.205 17.7066 21.7956 16.6875C21.6067 16.2735 21.5122 16.1143 21.3548 16.1143C21.1659 16.1143 21.0714 16.3053 20.851 16.8467L16.4427 28.248C16.0963 29.1716 15.7499 29.7767 14.9627 29.8722C14.8368 29.9041 14.5849 29.9041 14.4274 29.9041C14.3015 29.9041 14.207 29.9359 14.207 30.0633C14.207 30.2225 14.3015 30.2544 14.5534 30.2544C15.4665 30.2544 16.4427 30.1907 16.6316 30.1907C17.1669 30.1907 17.9226 30.2544 18.4894 30.2544C18.6783 30.2544 18.7728 30.2225 18.7728 30.0633C18.7728 29.9678 18.7098 29.9041 18.5209 29.9041H18.269C17.7337 29.9041 17.5762 29.6811 17.5762 29.3308C17.5762 29.1079 17.6707 28.6939 17.8281 28.2162L18.7728 25.6047C18.8043 25.5092 18.8358 25.4455 18.9302 25.4455M19.2451 24.5856L19.1821 24.4582L20.788 19.9996L20.8825 19.8404L20.9769 19.9996L22.5513 24.4901L22.4569 24.5856H19.2451Z" fill="white" />
                            <path d="M30.4221 27.0701C30.4221 30.637 30.4536 32.4523 29.1311 33.8536C28.7847 34.2039 28.5328 34.4268 28.3124 34.5542C28.029 34.7134 27.9346 34.7771 27.9346 34.8727L28.0605 35.0319C28.155 35.0319 28.2809 35 28.4069 34.9364C28.7533 34.7453 29.0366 34.6179 29.2571 34.4586C30.8944 33.3758 31.8076 32.1338 32.1854 31.0192C32.5318 30 32.5948 28.8217 32.5948 27.8026C32.5948 26.9109 32.5318 26.0192 32.5318 25.2548V21.8472C32.5318 19.0765 32.5318 18.5669 32.5633 17.9937C32.5948 17.3567 32.7207 17.0383 33.193 16.9746C33.4135 16.9427 33.5079 16.9109 33.6969 16.9109C33.9173 16.9109 34.0117 16.879 34.0117 16.7516C34.0117 16.6243 33.8858 16.5924 33.6339 16.5924C32.9726 16.5924 31.8706 16.6561 31.4612 16.6561C31.0204 16.6561 29.9183 16.5924 29.0366 16.5924C28.7847 16.5924 28.6588 16.6243 28.6588 16.7516C28.6588 16.879 28.7533 16.9109 28.9422 16.9109C29.1941 16.9109 29.4775 16.9427 29.6034 16.9746C30.1702 17.102 30.2962 17.3886 30.3276 17.9937C30.3591 18.5669 30.3591 19.0765 30.3591 21.8472" fill="white" />
                        </svg>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '4px' }}>
                            <span style={{ color: "#161922", fontSize: '16px' }}>Taj Hotel</span>
                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>1245 Grand Avenue, Ojai, CA</span>
                        </div>
                    </div>
                }
            />
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                }}
            >
            <div className="header-section">
                <div className="header-content">
                    <Typography className="heading-text">Welcome!</Typography>
                    <span className="subheading-text">Here’s what you need to focus on today</span>
                </div>

            </div>

            <div className="detail-section">
                {cardsData.map((item, index) => (
                    <div className="detail-card" key={index}>
                        <div className="card-content1">
                            <div className="card-header">
                                <div
                                    className={
                                        index === 0
                                            ? "card-icon3"
                                            : index === 1
                                                ? "card-icon1"
                                                : "card-icon2"
                                    }
                                >
                                    {item.icon}
                                </div>
                                <span className="card-title">{item.title}</span>
                            </div>
                            <span className="card-value">{item.value}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ display: "flex", gap: "24px", marginLeft: "20px", marginRight: "20px", marginTop: "24px" }}>
                <div className="table-section">
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginBottom: "16px" }}>
                        <span className="table-title">Corporate Overview</span>
                        <span className="table-subtitle">Here's what you need to focus on today</span>
                    </div>
                   <div style={{width: '100%', height:'280px'}}>
                   <AgTableClient
                    columnDefs={columnDefs}
                    rowData={rowData}
                    ref={ref}
                    groupPanel
                />
                   </div>
                </div>
            </div>

            {/* Charts Section */}
            <div style={{ display: "flex", gap: "24px", marginLeft: "20px", marginRight: "20px", marginTop: "24px" }}>
                {/* Performance Chart */}
                <div className="chart-section" style={{ flex: 1 }}>
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "flex-start",
                        marginBottom: "16px" 
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            <span className="table-title">Performance</span>
                            <span className="table-subtitle">Here's what you need to focus on today</span>
                        </div>
                        <Select
                            value={selectedYear}
                            onChange={setSelectedYear}
                            suffixIcon={<DownOutlined />}
                            style={{ 
                                width: 100,
                                borderRadius: '4px'
                            }}
                            options={[
                                { label: '2025', value: '2025' },
                                { label: '2024', value: '2024' },
                                { label: '2023', value: '2023' },
                            ]}
                        />
                    </div>
                    <div style={{ marginTop: "20px", width: '100%', height: '300px' }}>
                        <AgCharts options={performanceChartOptions} />
                    </div>
                </div>

                {/* Ranking Chart */}
                <div className="chart-section" style={{ flex: 1 }}>
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "flex-start",
                        marginBottom: "16px" 
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            <span className="table-title">Ranking</span>
                            <span className="table-subtitle">Here's what you need to focus on today</span>
                        </div>
                        <Select
                            value={selectedYear}
                            onChange={setSelectedYear}
                            suffixIcon={<DownOutlined />}
                            style={{ 
                                width: 100,
                                borderRadius: '4px'
                            }}
                            options={[
                                { label: '2025', value: '2025' },
                                { label: '2024', value: '2024' },
                                { label: '2023', value: '2023' },
                            ]}
                        />
                    </div>
                    <div style={{ marginTop: "20px", width: '100%', height: '300px' }}>
                        <AgCharts options={rankingChartOptions} />
                    </div>
                </div>
            </div>

            <Modal
                open={isPromoteModalOpen}
                onCancel={() => setIsPromoteModalOpen(false)}
                footer={null}
                width={900}
                className="promote-modal"
                closable={false}
            >
                <div className="promote-modal-content">
                    {/* Header */}
                    <div className="promote-modal-header">
                        <Typography className="promote-modal-title">Promote</Typography>
                        <CloseOutlined
                            className="promote-modal-close"
                            onClick={() => setIsPromoteModalOpen(false)}
                        />
                    </div>

                    {/* Body */}
                    <div className="promote-modal-body">
                        {/* Left Section - Clients */}
                        <div className="promote-modal-left">
                            <div className="promote-clients-header">
                                <Typography className="promote-clients-title">Clients</Typography>
                                <Checkbox
                                    checked={selectAll}
                                    onChange={(e) => {
                                        setSelectAll(e.target.checked);
                                        if (e.target.checked) {
                                            setSelectedClients(clientsList.map(c => c.id));
                                        } else {
                                            setSelectedClients([]);
                                        }
                                    }}
                                >
                                    Select all
                                </Checkbox>
                            </div>
                            <div className="promote-clients-list">
                                {clientsList.map((client) => (
                                    <Checkbox
                                        key={client.id}
                                        checked={selectedClients.includes(client.id)}
                                        onChange={(e) => {
                                            let newSelected;
                                            if (e.target.checked) {
                                                newSelected = [...selectedClients, client.id];
                                            } else {
                                                newSelected = selectedClients.filter(id => id !== client.id);
                                                setSelectAll(false);
                                            }
                                            setSelectedClients(newSelected);
                                            // Update select all if all clients are selected
                                            if (newSelected.length === clientsList.length) {
                                                setSelectAll(true);
                                            }
                                        }}
                                    >
                                        {client.name}
                                    </Checkbox>
                                ))}
                            </div>
                        </div>

                        {/* Right Section - Promotion Details */}
                        <div className="promote-modal-right">
                            {/* Compliance Score */}
                            <div className="promote-section promote-compliance-section">
                                <div className="promote-compliance-header">
                                    <div>
                                        <Typography className="promote-label">Your Compliance Score</Typography>
                                        <Typography className="promote-score-note">
                                            This will be highlighted in<br /> your promotional message
                                        </Typography>
                                    </div>
                                    <Typography className="promote-score-value">88%</Typography>
                                </div>
                                <div className="promote-section promote-attachments-section">
                                    <div className="promote-label-with-icon">
                                        <Typography className="promote-label">Attachments</Typography>
                                        <InfoCircleOutlined className="promote-info-icon" />
                                    </div>
                                    <Upload>
                                        <Button
                                            icon={<CloudUploadOutlined />}
                                            className="promote-upload-btn"
                                        >
                                            Upload
                                        </Button>
                                    </Upload>
                                </div>
                            </div>

                            {/* Attachments */}


                            {/* Subject */}
                            <div className="promote-section">
                                <Typography className="promote-label">Subject</Typography>
                                <Input placeholder="Choose a category" />
                            </div>

                            {/* Body */}
                            <div className="promote-section">
                                <Typography className="promote-label">Body</Typography>
                                <Input.TextArea
                                    placeholder="Choose a category"
                                    rows={4}
                                />
                            </div>

                            {/* Contact Information */}
                            <div className="promote-section">
                                <Typography className="promote-label">Contact Information</Typography>
                                <Input placeholder="Name" style={{ marginBottom: '12px' }} />
                                <div className="promote-contact-row">
                                    <Input placeholder="Email" style={{ flex: 1 }} />
                                    <Input placeholder="Phone" style={{ flex: 1, marginLeft: '12px' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="promote-modal-footer">
                        <Button
                            onClick={() => setIsPromoteModalOpen(false)}
                            className="promote-cancel-btn"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            className="promote-send-btn"
                        >
                            Send Promotion
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Assign Member Modal */}
            <Modal
                open={isAssignMemberModalOpen}
                onCancel={() => {
                    setIsAssignMemberModalOpen(false);
                    form.resetFields();
                }}
                footer={null}
                width={600}
                styles={{
                    header: {
                        background: '#0a8394',
                        padding: '16px 24px',
                        borderRadius: '8px 8px 0 0'
                    },
                    body: {
                        padding: '24px'
                    }
                }}
                title={
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        color: 'white'
                    }}>
                        <span style={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>Add Team Member</span>
                        <span 
                            onClick={() => {
                                setIsAssignMemberModalOpen(false);
                                form.resetFields();
                            }}
                            style={{ 
                                color: 'white', 
                                cursor: 'pointer', 
                                fontSize: '20px',
                                lineHeight: '1'
                            }}
                        >
                            ×
                        </span>
                    </div>
                }
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => {
                        console.log('Form values:', values);
                        // Close modal and reset form
                        setIsAssignMemberModalOpen(false);
                        form.resetFields();
                    }}
                >
                    <Form.Item
                        label={<span>Name <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="name"
                        required={false}
                        rules={[{ required: true, message: 'Please enter full name' }]}
                    >
                        <Input 
                           style={{marginBottom: '16px'}}
                            placeholder="Enter full name"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Role <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="role"
                        required={false}
                        rules={[{ required: true, message: 'Please enter role/position' }]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter role/position"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Phone Number <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="phoneNumber"
                        required={false}
                        rules={[
                            { required: true, message: 'Please enter phone number' },
                            { pattern: /^\d{10}$/, message: 'Please enter a valid 10-digit phone number' }
                        ]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter 10-digit phone number"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Email <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="email"
                        required={false}
                        rules={[
                            { required: true, message: 'Please enter email address' },
                            { type: 'email', message: 'Please enter a valid email address' }
                        ]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter email address"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Status <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="status"
                        required={false}
                        rules={[{ required: true, message: 'Please choose status' }]}
                    >
                        <Select
                            placeholder="Choose status"
                            style={{ width: '100%' }}
                        >
                            <Select.Option value="Open">Open</Select.Option>
                            <Select.Option value="Hidden">Hidden</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <Button
                                onClick={() => {
                                    setIsAssignMemberModalOpen(false);
                                    form.resetFields();
                                }}
                                style={{
                                    background: 'white',
                                    color: '#161922',
                                    borderColor: '#E1E6EA'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    background: '#0a8394',
                                    borderColor: '#0a8394'
                                }}
                            >
                                Add Member
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
            </div>
        </div>
    );
}

export default DashboardHotels;

